import instance from './index.js';

export const createModule = async (module) => {
  try {
    const response = await instance.post("/moduleOperation", module);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllModules = async () => {
  try {
    const response = await instance.get("/moduleOperation/getAll");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createRole = async (role) => {
  try {
    const response = await instance.post("/jobTitleToModuleOperation", role);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateRole = async (role, id) => {
  try {
    const response = await instance.put(`/jobTitleToModuleOperation/update/${id}`, role);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllRoles = async () => {
  try {
    const response = await instance.get("/jobTitleToModuleOperation/getAll");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Gives information related to what to show on user screen.
export const getAllPermissions = async (authToken) => {
  try {
    const response = await instance.get("/jobTitleToModuleOperation/getAllPermission", {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};